import { ANCHOR_BOTTOM, ANCHOR_LEFT, ANCHOR_RIGHT, ANCHOR_TOP } from '../../../primitives/Sticky/models.js';
export const getRootMargin = (anchor, anchorOffset) => {
  const margin = anchorOffset * -1;
  switch (anchor) {
    case ANCHOR_TOP:
      {
        return `${margin}px 0px 0px 0px`;
      }
    case ANCHOR_RIGHT:
      {
        return `0px ${margin}px 0px 0px`;
      }
    case ANCHOR_BOTTOM:
      {
        return `0px 0px ${margin}px 0px`;
      }
    case ANCHOR_LEFT:
      {
        return `0px 0px 0px ${margin}px`;
      }
    default:
      {
        return '0px';
      }
  }
};